<template lang="pug">
    multiselect(
        :value="value"
        :options="branchList"
        placeholder="Type to search",
        label="name"
        track-by="name"
        name="branch_id"
        @input="onInput"
        :disabled="disabled"
        :loading="branch_loading"
        :internalSearch="false"
        @search-change="loadBranch"
    )
        template(slot="option" slot-scope="props")
            span.block {{ props.option.name }}
</template>

<script>
import branch from '@js/store/modules/branch';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            branchList: [],
            branch_loading: false,
        };
    },
    beforeCreate() {
        if (!this.$store.hasModule('branch')) {
            this.$store.registerModule('branch', branch);
        }
    },
    mounted() {
        this.loadBranch();
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
        },

        loadBranch: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.branch');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };
            this.branch_loading = true;
            return axios
                .get(api, options)
                .then(res => {
                    this.branchList = res.data.data;
                    this.branch_loading = false;
                })
                .catch(err => {
                    throw err;
                });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/BranchSelector.vue